/**
 * E182.F1 (ADR-0135 §2.1): o resultado principal da geolocalização no painel do eixo — a distância
 * em linha reta entre a coordenada do ato e o endereço que o signatário declarou no contrato, com a
 * faixa da régua e o nível em que o endereço foi localizado. Sem distância, o motivo do exame.
 */
import { Badge, MonoData } from '@/components/ui';
import { ptBR } from '@/i18n/pt-BR';
import type { LocalizacaoApuradaData } from '@/lib/exame_eletronico_localizacao';

import { formatarDistancia } from './QuadroVerificacaoCluster';
import { Titulo } from './QuadroVerificacaoTabelas';

const t = ptBR.exameEletronico.quadro;
/** A classe de precisão vem do geocodificador como texto livre; fora da tabela, nada se diz. */
const NIVEL_DO_ENDERECO: Readonly<Record<string, string | undefined>> = t.precisaoDoEnderecoOpcoes;

export function GeolocalizacaoPrincipal({
  localizacao,
}: {
  localizacao: LocalizacaoApuradaData | null | undefined;
}): JSX.Element | null {
  if (!localizacao) return null;
  const declarado = localizacao.endereco_declarado;
  const distancia = declarado?.distancia_m;
  const nivel = declarado?.precisao_geocodificacao
    ? NIVEL_DO_ENDERECO[declarado.precisao_geocodificacao]
    : undefined;
  return (
    <section data-testid="geolocalizacao-principal">
      <Titulo>{t.geolocalizacaoPrincipal}</Titulo>
      <p className="mb-sc-2 text-caption text-fg-dim">{t.geolocalizacaoPrincipalComoLer}</p>
      {declarado && typeof distancia === 'number' ? (
        <p className="flex flex-wrap items-center gap-sc-2" data-testid="geolocalizacao-medida">
          <MonoData>{formatarDistancia(distancia)}</MonoData>
          <Badge variant="neutral">{t.faixaOpcoes[declarado.faixa]}</Badge>
          {nivel ? <span className="text-caption text-fg-dim">{nivel}</span> : null}
        </p>
      ) : (
        <p className="text-body-sm text-fg-dim" data-testid="geolocalizacao-nao-medida">
          {declarado?.detalhe ?? t.geolocalizacaoSemDistancia}
        </p>
      )}
    </section>
  );
}
